import AddFamilyPage from '@/pages/AddFamily';
import FamilyDetails from '@/pages/AddFamily/views/FamilyDetails';
import FamilyConsent from '@/pages/AddFamily/views/FamilyConsent';
import FamilySource from '@/pages/AddFamily/views/FamilySource';
import FamilyInformation from '@/pages/AddFamily/views/FamilyInformation';
import FamilySummary from '@/pages/AddFamily/views/FamilySummary';

export default {
    path: '/dodaj-rodzine',
    component: AddFamilyPage,
    meta: { requiresAuth: true, requiresPermissions: ['szp_family_edition_add'] },
    children: [
        {
            path: '',
            name: 'add-family',
            redirect: { name: 'family-consent' }
        },
        {
            path: 'dane',
            name: 'family-details',
            component: FamilyDetails
        },
        {
            path: 'zgoda',
            name: 'family-consent',
            component: FamilyConsent
        },
        {
            path: 'zrodlo',
            name: 'family-source',
            component: FamilySource
        },
        {
            path: 'informacja',
            name: 'family-information',
            component: FamilyInformation
        },
        {
            path: 'dodano',
            name: 'family-summary',
            component: FamilySummary,
            props: { isGlued: false }
        }
    ]
};
